// Crude URL parameter detection over the entire url
export const jsDebugEnabled = (): boolean => {
  const regex = new RegExp('[\\?&]:jsdebug=(1|true)');
  // This cannot use `window.location.search` because `:jsdebug`
  // is found after the `#` and not part of the query string.
  return !!regex.exec(window.location.href);
};
